import { debugLog } from '../../../../network/debug-logger';
import { type SocketMachineContext } from '../../../network-state-machine-context';

export function onEnterConnected(ctx: SocketMachineContext) {
  ctx.pendingMessages.resetPredicate();

  // This needs to happen AFTER the predicate is reset, since downstream dependencies
  // will want to write messages as soon as the connection is open.
  //
  // If called before, the messages won't end up getting queued due to the predicate and
  // will end up dropped!
  ctx.socketConnect?.();

  onReEnterConnected(ctx);
}

export function onReEnterConnected(ctx: SocketMachineContext) {
  const pending = ctx.pendingMessages.dequeueAll();
  debugLog(
    '[onEnterConnected:drainQueue] draining %d pending message(s) via transport.send()',
    pending.length
  );
  for (const pendingMessage of pending) {
    ctx.transport?.send(pendingMessage.message);
  }
}

export function onExitConnected(ctx: SocketMachineContext) {
  ctx.pendingMessages.setPredicate((message) => message.enqueue);

  ctx.transport?.dispose();
  ctx.transport = undefined;
}
